import { useState, useEffect } from 'react';

const PhantomInAppWarning = () => {
  const [isPhantomInApp, setIsPhantomInApp] = useState(false);
  const [copied, setCopied] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const ua = navigator.userAgent || '';
    const isInApp = /Phantom/i.test(ua) || /SolanaWallet/i.test(ua);

    if (isInApp) {
      setIsPhantomInApp(true);
    }
  }, []);

  const handleCopyUrl = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (error) {
      console.error('URLコピー失敗:', error);
    }
  };

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          url: window.location.href,
          title: document.title,
        });
      } catch (error) {
        console.error('共有失敗:', error);
      }
    }
  };

  if (!isPhantomInApp || dismissed) {
    return null;
  }

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-yellow-500 text-black shadow-lg">
      <div className="max-w-4xl mx-auto px-4 py-3">
        <div className="flex items-start justify-between gap-3">
          <div className="flex-1">
            <p className="font-bold text-sm mb-1">
              ⚠️ Phantomウォレット内で開かれています
            </p>
            <p className="text-xs mb-2">
              ウォレット認証を行うには、Safari/Chromeで開いてください
            </p>

            <div className="flex gap-2">
              <button
                onClick={handleCopyUrl}
                className="flex items-center gap-1 px-3 py-1.5 bg-white text-yellow-700 rounded-lg text-xs font-medium hover:bg-gray-100 transition-colors"
              >
                📋 {copied ? 'コピーしました！' : 'URLをコピー'}
              </button>

              {navigator.share && (
                <button
                  onClick={handleShare}
                  className="flex items-center gap-1 px-3 py-1.5 bg-white text-yellow-700 rounded-lg text-xs font-medium hover:bg-gray-100 transition-colors"
                >
                  🔗 共有
                </button>
              )}
            </div>
          </div>

          <button
            onClick={() => setDismissed(true)}
            className="flex-shrink-0 p-1 hover:bg-yellow-600 rounded transition-colors"
            aria-label="閉じる"
          >
            ✕
          </button>
        </div>
      </div>
    </div>
  );
};

export default PhantomInAppWarning;
